// providers/MountedProvider.tsx
"use client";
import { Provider } from "react-redux";
import { store } from "../lib/store";
import { ReactNode, useEffect, useState } from "react";
import MobileNavProvider from "./MobileNavProvider";
import SettingsInitializerProvider from "./SettingsInitializerProvider";
import HeaderInitializerProvider from "./HeaderInitializerProvider";
import MenusInitializerProvider from "./MenusInitializerProvider";
import FooterInitializerProvider from "./FooterInitializerProvider";
import WebVisitLoggerProvider from "./WebVisitLoggerProvider";
import { MobileTokenInitializer } from "./MobileTokenProvider";
import AppEffects from "./AppEffects";
import { Settings } from "../lib/features/settings/settings.types";
import { HeaderData } from "../lib/features/header/header.types";
import { MenuItem } from "../lib/features/menus/menus.types";
import { FooterData } from "../lib/features/footer/footer.types";

interface MountedProviderProps {
  children: ReactNode;
  initialSettings?: Settings;
  initialHeader?: HeaderData | null;
  initialMenus?: MenuItem[] | null;
  initialFooter?: FooterData | null;
}

const MountedProvider = ({ children, initialSettings, initialHeader, initialMenus, initialFooter }: MountedProviderProps) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => { setMounted(true); }, []);

  return (
    <Provider store={store}>
      <SettingsInitializerProvider initialSettings={initialSettings} />
      <HeaderInitializerProvider initialHeader={initialHeader} />
      <MenusInitializerProvider initialMenus={initialMenus} />
      <FooterInitializerProvider initialFooter={initialFooter} />
      <AppEffects />
      {mounted && <WebVisitLoggerProvider />}
      {mounted && <MobileTokenInitializer />}
      <MobileNavProvider>{children}</MobileNavProvider>
    </Provider>
  );
};

export default MountedProvider;
